// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_loaderContainer__IAyzF {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: transparent;
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 100%;
  top: 0;
}

.styles_loader__FcYd9 {
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--theme-secondary); 
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: styles_spin__-CXuo 1s linear infinite;
}

@keyframes styles_spin__-CXuo {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (min-width: 767px) {
  .styles_loaderContainer__IAyzF {
    max-width: 500px;
    margin: 0 auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/InnerLoader/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF","sourcesContent":[".loaderContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: transparent;\n  position: fixed;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n  top: 0;\n}\n\n.loader {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid var(--theme-secondary); \n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@media (min-width: 767px) {\n  .loaderContainer {\n    max-width: 500px;\n    margin: 0 auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderContainer": `styles_loaderContainer__IAyzF`,
	"loader": `styles_loader__FcYd9`,
	"spin": `styles_spin__-CXuo`
};
export default ___CSS_LOADER_EXPORT___;
